import { atom } from 'jotai'
import { AccountCapabilities } from '../useAccountCapabilities'

export const accountCapabilitiesAtom = atom({
  isPrincipleCustomerCapabilityEnabled: false,
  isBvnkNetworkCapabilityEnabled: false,
} as AccountCapabilities)
